
export type Shade = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;

/**
* Sees If Youre In Dev mode / google chrome etc
* isEnvBrowser() is how you call
*/
export const isEnvBrowser = (): boolean => !(window as any).invokeNative

export const noop = () => {}


/** used to translate a env string to a boolean */
export function envBool(value: string | undefined, fallback = false): boolean {
  if (value == null) return fallback;
  switch (value.trim().toLowerCase()) {
    case "true":
    case "1":
    case "yes":
    case "y":
    case "on":
      return true;
    case "false":
    case "0":
    case "no":
    case "n":
    case "off":
      return false;
    default:
      return fallback;
  }
}